// extracted by mini-css-extract-plugin
module.exports = {"logosBlock":"logos-module--logos-block--2JSL2","logosList":"logos-module--logos-list--5UjX-","listItem":"logos-module--list-item--2pHPR"};